const DropdownVariant = {
  FullWidth: 'fullWidth',
  Default: '_default',
};

export default DropdownVariant;
